<template>
  <div class="row ">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-7">
              {{ $I18n.t('paradas_sin_asociar') }}
            </div>
            <div class="col-md-5">
              <div class="input-group">
                <input
                  ref="inputFiltroSinAsociar"
                  v-model="filtroParadasSinAsociar"
                  type="text"
                  class="form-control"
                  :placeholder="$I18n.t('Filtrar')"
                >
                <span class="input-group-addon" @click="limpiarFiltroSinAsociar">
                  <i class="fa fa-eraser"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div v-if="!sinAsignar.length">
            {{ $I18n.t('paradas_todas_asociadas') }}
          </div>
          <draggable
            class="list-group m-l-lg m-r-lg"
            :list="sinAsignar"
            item-key="nombre"
            group="people"
            ghost-class="ghost-timeline"
          >
            <template #item="{element, index}">
              <div
                class="list-group-item bg-secondary m-b-xs"
                :class="{ hide: !cumpleFiltro(element)}"
              >
                {{ element.nombre }}
              </div>
            </template>
          </draggable>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          {{ $I18n.t('paradas_este_turno') }}
        </div>
        <input type="hidden" name="paradas" :value="valorInputParadas" >
        <div class="card-body">
          <p v-if="!asignadas.length" class="text-muted text-center">
            <i class="fa fa-info-circle"></i>
            {{ $I18n.t('paradas_anada_arrastrando') }}
          </p>
          <ul>
            <draggable
              class="timeline form-inline"
              :list="asignadas"
              item-key="nombre"
              group="people"
              ghost-class="ghost"
            >
              <template #item="{element, index}">
                <li>
                  <div class="timeline-badge">
                    {{ index + 1 }}
                  </div>
                  <div class="timeline-panel bg-secondary">
                    <div class="timeline-heading">
                      {{ element.nombre }}
                      <div class="pull-right">
                        <input-fecha-hora
                          v-model="element.hora"
                          :only-timepicker="true"
                          :minutes-step="1"
                          :clear-button="true"
                          position="bottom right"
                        />
                      </div>
                    </div>
                  </div>
                </li>
              </template>
            </draggable>
          </ul>
          <p v-if="asignadas.length" class="text-muted text-right">
            <i class="fa fa-info-circle"></i>
            {{ $I18n.t('debe_guardar_cambios') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import { transporte } from 'cifra-api-js';
import { localISODateTimeString, timeStringToDate } from '../../../libs/dates';

export default {
  components: {
    draggable,
  },
  props: {
    iniciales: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      asignadas: [],
      sinAsignar: [],
      guardando: false,
      filtroParadasSinAsociar: undefined,
    };
  },
  computed: {
    valorInputParadas() {
      return JSON.stringify(this.asignadas);
    },
  },
  mounted() {
    transporte.paradas.get().then((result) => {
      // recibimos paradas pero nosotros almacenaremos turno_parada porque necesitamos
      // llevar el control de la hora
      this.sinAsignar = result.data.map((parada) => (
        {
          parada_id: parada.id,
          nombre: parada.nombre,
          hora: null,
        }
      ));

      this.iniciales.forEach((turnoParadaInicial) => {
        const turnoParada = this.sinAsignar.find((e) => (
          e.parada_id === turnoParadaInicial.parada_id
        ));
        if (!turnoParada) {
          return;
        }
        if (turnoParadaInicial.hora) {
          turnoParada.hora = localISODateTimeString(timeStringToDate(turnoParadaInicial.hora));
        }
        this.asignadas.push(turnoParada);
      });
      const idsParadasIniciales = this.iniciales.map((e) => e.parada_id);
      this.sinAsignar = this.sinAsignar.filter((element) => (
        !idsParadasIniciales.includes(element.parada_id)
      ));
    });
  },
  methods: {
    limpiarFiltroSinAsociar() {
      this.filtroParadasSinAsociar = undefined;
      this.$refs.inputFiltroSinAsociar.focus();
    },
    cumpleFiltro(parada) {
      if (!this.filtroParadasSinAsociar) {
        return true;
      }
      const filtro = this.filtroParadasSinAsociar.toLowerCase();
      return parada.nombre.toLowerCase().includes(filtro);
    },
  },
};
</script>

<style scoped>
.card {
  height: calc(100vh - 400px);
  min-height: 350px;
}

.buttons {
  margin-top: 35px;
}

.ghost,
.ghost-timeline {
  opacity: 0.5;
  background: #c8ebfb;
  border: 1px dashed black;
}

.ghost-timeline {
  list-style: none;
}

.ghost-timeline .timeline-badge {
  display: none;
}

.list-group {
  min-height: 80px;
}

.list-group-item {
  background-color: #fff;
}

/* CSS cogido de: https://bootsnipp.com/snippets/RX5Er */
.timeline {
  list-style: none;
  padding: 0 0 20px;
  position: relative;
  margin-top: -15px;
}
.timeline:before {
  top: 30px;
  bottom: 25px;
  position: absolute;
  content: " ";
  width: 3px;
  background-color: #ccc;
  left: 25px;
  margin-right: -1.5px;
}
.timeline > li,
.timeline > li > .timeline-panel {
  margin-bottom: 5px;
  position: relative;
}
.timeline > li:after,
.timeline > li:before {
  content: " ";
  display: table;
}
.timeline > li:after {
  clear: both;
}
.timeline > li > .timeline-panel {
  margin-left: 55px;
  float: left;
  top: 19px;
  padding: 4px 10px 8px 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 80%;
  background-color: #FFF;
}
.timeline > li > .timeline-badge {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 1.2em;
  text-align: center;
  position: absolute;
  top: 26px;
  left: 9px;
  margin-right: -25px;
  background-color: #fff;
  z-index: 100;
  border-radius: 50%;
  border: 1px solid #d4d4d4;
}
.timeline > li.timeline-inverted > .timeline-panel {
  float: left;
}
.timeline > li.timeline-inverted > .timeline-panel:before {
  border-right-width: 0;
  border-left-width: 15px;
  right: -15px;
  left: auto;
}
.timeline > li.timeline-inverted > .timeline-panel:after {
  border-right-width: 0;
  border-left-width: 14px;
  right: -14px;
  left: auto;
}
.timeline-badge.primary {
  background-color: #2e6da4 !important;
}
.timeline-badge.success {
  background-color: #3f903f !important;
}
.timeline-badge.warning {
  background-color: #f0ad4e !important;
}
.timeline-badge.danger {
  background-color: #d9534f !important;
}
.timeline-badge.info {
  background-color: #5bc0de !important;
}
.timeline-title {
  margin-top: 0;
  color: inherit;
}
.timeline-body > p,
.timeline-body > ul {
  margin-bottom: 0;
  margin-top: 0;
}
.timeline-body > p + p {
  margin-top: 5px;
}
.timeline-body > h4 {
  margin-bottom: 0 !important;
}
</style>
